module.exports = __webpack_public_path__ + "img/LogoLight.69cb6452.svg";